import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VMain,{staticClass:"emailChangeVerification"},[_c(VContainer,[_c(VRow,{attrs:{"no-gutters":"","justify-center":"","align-center":""}},[_c(VCol,{staticClass:"instructions",attrs:{"cols":"12","xs":"12","sm":"6","offset-sm":"3"}},[_c('p',[_vm._v("Your email address change will be completed once you have successfully logged in from this device. If you are not redirected in 5 seconds, click "),_c('a',{attrs:{"href":_vm.appUrl}},[_vm._v("here")]),_vm._v(" to log in to your account.")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }